import { Box, Text, IconButton, Link } from '@chakra-ui/react'
import { IoClose } from 'react-icons/io5'

const MonthlyCourseErrorCancelledDialog = ({ isOpen, onClose, cancelledCourses = [] }) => {
  if (!isOpen) return null

  const courseLabel = cancelledCourses.map((c) => `【月額${c.monthly_course_name}】`).join('')

  return (
    <Box bg="primary.50" border="0.5px solid" borderColor="primary.400" borderRadius="base" py={2} px={5} my={4} position="relative">
      <IconButton
        icon={<IoClose />}
        aria-label="閉じる"
        onClick={onClose}
        position="absolute"
        bg="white"
        top="-10px"
        right="-10px"
        borderRadius="full"
        width="21px"
        height="21px"
        minW="21px"
      />
      <Text textAlign="center" color="label.accent" fontSize="3xs" wordBreak="keep-all">
        {courseLabel}
        <br />
        決済処理でエラーが発生しました。
        <br />
        大変お手数ですが、
        <wbr />
        カード情報の更新をして再登録をお願い致します。
        <br />
        <Link href="/user/monthly_course_histories">こちら</Link>から再登録をすると、
        <wbr />
        継続ボーナスが引き続き付与されます。
      </Text>
    </Box>
  )
}

export default MonthlyCourseErrorCancelledDialog
